<mic-breadcrumb id="accessibility-statement-breadcrumb">
  <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
  <mic-breadcrumb-link label="{{ translationService.translate('helpText') }}"></mic-breadcrumb-link>
  <mic-breadcrumb-link
    link="/home/help/accessibility-statement"
    label="{{ translationService.translate('accessibilityStatementText') }}"
  ></mic-breadcrumb-link>
</mic-breadcrumb>
<main>
  <h1 class="font-michelin-unit-titling">{{ translationService.translate('accessibilityStatementText') }}</h1>
  <section>
    <h2 class="font-noto-sans-bold btn-color-blue">{{ translationService.translate('accessibilityStatementIntroductionHeader') }}</h2>
    <p class="font-noto-sans-regular">
      {{ translationService.translate('accessibilityStatementCommitmentText') }}
    </p>
    <p class="font-noto-sans-regular">{{ translationService.translate('accessibilityStatementStrategyAndActionsText') }}</p>
    <ul class="font-noto-sans-regular">
      <li>
        <a href="https://www.michelin.com/en/multi-annual-plan/" target="_blank" rel="noopener noreferrer"
          >Multi-Year accessibility plan 2024-2027</a
        >
      </li>
      <li>{{ translationService.translate('accessibilityStatementActionPlanText') }}</li>
    </ul>
    <p class="font-noto-sans-regular">
      {{ translationService.translate('accessibilityStatementAppliesToText') }}
      @if (appUrl) {
      <a [href]="appUrl">{{ appUrl }}</a>
      }
    </p>
  </section>
  <section>
    <h2 class="font-noto-sans-bold btn-color-blue">{{ translationService.translate('accessibilityStatementComplianceHeader') }}</h2>
    <p class="font-noto-sans-regular">
      {{ translationService.translate('accessibilityStatementComplianceBeforeWcagText') }} Web Content Accessibility Guidelines (WCAG) 2.1
      and 2.2{{ translationService.translate('accessibilityStatementComplianceAfterWcagBeforeUrlText') }}
      <a [href]="appUrl">{{ appUrl }}</a>
      {{ translationService.translate('accessibilityStatementComplianceAfterUrlText') }}
    </p>
    <p class="font-noto-sans-regular">
      {{ translationService.translate('accessibilityStatementEstablishedOnText') }} {{ formattedPublishDate }}
    </p>
  </section>
  <section>
    <h2 class="font-noto-sans-bold btn-color-blue">{{ translationService.translate('accessibilityStatementFeedbackHeader') }}</h2>
    @if (environment.envName.includes('na')) {
    <p class="font-noto-sans-regular">
      {{ translationService.translate('accessibilityStatementUsContactBeforePhoneText') }}
      <a href="tel:18668666605">1-866-866-6605</a>
      {{ translationService.translate('accessibilityStatementOrText') }}
      <a href="mailto:btn.support@michelin.com">{{ translationService.translate('accessibilityStatementEmailUsLinkText') }}</a>
      {{ translationService.translate('accessibilityStatementUsContactAfterEmailText') }}
    </p>
    } @else if (environment.envName.includes('sa') || environment.envName.includes('eu')) {
    <p class="font-noto-sans-regular">
      {{ translationService.translate('accessibilityStatementOtherContactBeforeEmailText') }}
      <a href="mailto:a11y@michelin.com">a11y&#64;michelin.com</a>
      {{ translationService.translate('accessibilityStatementOtherContactAfterEmailText') }}
    </p>
    }
  </section>
</main>
